import React from 'react';

export function FavoriteColoredIcon({ className, width = 30, height = 30 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.3275 10.401C28.3275 6.3135 25.014 3 20.9272 3C18.4462 3 16.257 4.22475 14.9137 6.09675C13.5705 4.22475 11.3813 3 8.901 3C4.8135 3 1.5 6.31275 1.5 10.401C1.5 10.98 1.5735 11.541 1.6995 12.0817C2.727 18.4665 9.82575 25.2022 14.9137 27.0518C20.001 25.2022 27.1005 18.4665 28.1265 12.0825C28.254 11.5417 28.3275 10.9808 28.3275 10.401Z"
        fill="#C80E57"
      />
    </svg>
  );
}
